module.exports = __webpack_public_path__ + "static/woman-elderly-window-square-mirror.bed126db.jpg";